<template>
	<div id="page-user-edit">
		<bread-crumbs
			:title="$t('Reports.Generate') + ' ' + $t('Reports.Reports')"
			:subTitle="$t('general.SubtitleReports')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		></bread-crumbs>
		<div class="tab-text">
			<report-form v-if="repportCreatePermission" />
			<not-permission v-else></not-permission>
		</div>
	</div>
</template>

<script>
import ReportForm from "./ReportForm.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	components: {
		ReportForm,
		NotPermission,
	},
	computed: {
		repportReadPermission() {
			return this.$store.getters.checkPermission("REPORTS_R");
		},
		repportCreatePermission() {
			return this.$store.getters.checkPermission("REPORTS_C");
		},
		repportUpdatePermission() {
			return this.$store.getters.checkPermission("REPORTS_U");
		},
	},
};
</script>
